<template>
  <div class="footer_copy_container">
    <div class="footer_container">
      <div class="flex" style="padding-top: 50px;justify-content: space-around">
        <div>
          <img src="../../../../static/img/logo.png" alt="" style="width: 160px;height: 40px">
          <img src="../../../../static/img/icon12.png" alt="" style="width: 100px;height: 100px;margin-top: 20px">
        </div>
        <div class="flex" style="justify-content: space-around;">
          <div class="t_1" @click="getUrl(2)">关于我们</div>
          <div class="t_1" @click="getUrl(3)">产品中心</div>
          <div class="t_1" @click="getUrl(4)">工程案例</div>
          <div class="t_1" @click="getUrl(5)">资料下载</div>
          <div class="t_1" @click="getUrl(6)">联系我们</div>
        </div>
        <div>
          <div class="flex" style="align-items: center">
            <img src="../../../../static/img/icon13.png" alt="" style="width: 15px;height: 15px">
            <div class="t_2">公司地址：江苏省苏州市相城区澄阳路国际科创园C座505</div>
          </div>
<!--          <div class="flex" style="align-items: center;margin-top: 20px">-->
<!--            <img src="../../../../static/img/icon14.png" alt="" style="width: 15px;height: 15px">-->
<!--            <div class="t_2">联系电话：186 2521 6693</div>-->
<!--          </div>-->
<!--          <div class="flex" style="align-items: center;margin-top: 20px">-->
<!--            <img src="../../../../static/img/icon15.png" alt="" style="width: 15px;height: 15px">-->
<!--            <div class="t_2">企业邮箱：deruimu@163.com</div>-->
<!--          </div>-->
        </div>
      </div>
      <div class="t_3">
        Copyright©2023 苏州德瑞姆电子科技有限公司 | 苏ICP备18037032号
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                tab: 0,
                dialogVisible1: false
            }
        },
        methods: {
            getUrl(index) {
                this.$emit('getTab', index); // 触发父组件的自定义事件
                //this.tab = index;
                if (index == 2) {
                    this.$router.replace("/about")
                }
                if (index == 3) {
                    this.$router.replace("/product")
                }
                if (index == 4) {
                    this.$router.replace("/case")
                }
                if (index == 5) {
                    this.$router.replace("/download")
                }
                if (index == 6) {
                    this.$router.replace("/contact")
                }
            },
        }
    }
</script>

<style scoped>
  .t_3 {
    font-family: HarmonyOS Sans SC;
    font-weight: 400;
    font-size: 14px;
    color: #CACED5;
    text-align: center;
    margin-top: 80px;
  }

  .t_2 {
    font-family: HarmonyOS Sans SC;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    margin-left: 5px;
  }

  .t_1 {
    font-family: HarmonyOS Sans SC;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    margin-left: 30px;
    cursor: pointer;
  }

  .footer_copy_container {
    height: 320px;
    background: #7D98BA;
    width: 100%;
    z-index: 1000;
  }


  .footer_container {
    width: 80%;
    margin: 0 auto;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppFooter.vue